module.exports = __webpack_public_path__ + "static/media/ship1.24790ff8.png";